import React, { useState, useEffect } from 'react'
import Head from 'next/head'
import Image from 'next/image'
import styles from '../../styles/Home.module.css'
import { supabase } from '../../utils/supabaseClient'
import StepForm from '../../components/form/HomepageStepForm/StepForm'
import Header from '../../components/Header'
import BackButtonModal from '../../components/modal/BackButtonModal'

export default function Home(props) {

    const [back, setBack] = useState(false)
    const [backOnce, setBackOnce] = useState(false)
    const [success, setSuccess] = useState(false)

    //for the back button
    // useEffect(() => {
    //     var mouseY = 0;
    //     var topValue = 0;
    //     if (backOnce) {
    //         setBack(false)
    //         const timer = setTimeout(() => {
    //             setBackOnce(false)
    //         }, 60000); //1 minute
    //         return () => clearTimeout(timer);
    //     } else {
    //         window.addEventListener("mouseout", function (e) {
    //             mouseY = e.clientY;
    //             if (mouseY < topValue) {
    //                 setBack(true)
    //             }
    //         },
    //             false);
    //     }
    // })

    return (
        <div>
            {/* {
                back && !success &&
                <div>
                    <BackButtonModal
                        did={'000-000-000'}
                        backOnce={backOnce}
                        setBackOnce={setBackOnce}
                        open={back}
                        setOpen={setBack}
                    />
                </div>
            } */}
            <Header title="Lawsuit Eligibility Test" description="Take this 2 min. quiz to see if you qualify for any of these product liability and personal injury lawsuits" keywords="personal injury lawsuit information" />
            <div className='banner'>
                <div className='min-h-screen max-w-4xl mx-auto flex pt-10 md:pt-0 md:items-center justify-center'>
                    <StepForm
                        setSuccess={setSuccess}
                        lawsuits={props.lawsuits}
                        source="Craftwise LLC"
                    />
                </div>
            </div>
            <style>
                {
                    `.banner {
                background-image: url("https://images.unsplash.com/photo-1603796846097-bee99e4a601f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1674&q=80"); /* The image used */
                background-color: #cccccc; /* Used if the image is unavailable */
                height: 100%;
                /* Create the parallax scrolling effect */
                background-attachment: fixed;
                background-position: center;
                background-repeat: no-repeat;
                background-size: cover;
                z-index: auto;
            }`
                }
            </style>
        </div>
    );
}

export const getStaticProps = async () => {
    const { data: lawsuits } = await supabase
        .from('lawsuits')
        .select(`
      id,
      title,
      subtitle,
      products,
      product_image,
      injuries,
      slug,
      published
  `)
        .eq("published", true)


    return {
        props: {
            lawsuits
        }
    }
}
